import { InMemoryCache } from "@apollo/client";

export const cache = new InMemoryCache({
  possibleTypes: {
    QrDescriptionUnion: ["ArtQrDescriptionType", "BaseQrDescriptionType"],
  },
  typePolicies: {
    PaymentType: {
      keyFields: false, // Store it as an embedded object, without normalization
    },
    PaymentOrderType: {
      keyFields: false,
    },
    ArtQrDescriptionType: {
      keyFields: false,
    },
    BaseQrDescriptionType: {
      keyFields: false,
    },
    GeoDataType: {
      keyFields: false,
    },
    FolderSharedUserType: {
      keyFields: false,
    },
    Query: {
      fields: {
        payment: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming);
          },
        },
        entryData: {
          merge(_, incoming) {
            return {
              ...incoming,
              userEntries: {
                ...incoming.userEntries,
                items: incoming.userEntries?.items ?? [],
              },
            };
          },
        },
        geo: {
          merge: true,
        },
      },
    },
    UserType: {
      fields: {
        alternativeNotifyEmail: {
          merge(_, incoming) {
            return incoming;
          },
        },
        emailNotificationTypes: {
          merge(_, incoming) {
            return incoming;
          },
        },
        phones: {
          merge(_, incoming) {
            return incoming;
          },
        },
      },
    },
  },
});
